import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { ConversionArchivesClient, ConversionDataType } from '../../generated-client/generated-client';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { combineLatest, of } from 'rxjs';

import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'da-conversion-archive',
  templateUrl: './conversion-archive.component.html',
  styleUrls: ['./conversion-archive.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatFormField, MatLabel, MatInput, FormsModule, MatButton, DatePipe]
})
export class ConversionArchiveComponent implements OnInit {
  private conversionArchivesClient = inject(ConversionArchivesClient);

  oldestAvaToAvaConversionPresent = signal<Date>(null);
  oldestGaebToAvaConversionWithoutPersistencePresent = signal<Date>(null);

  private _daysToKeep = signal(14);
  get daysToKeep(): number { return this._daysToKeep(); }
  set daysToKeep(value: number) { this._daysToKeep.set(value); }
  private _daysToKeepGaebToAva = signal(14);
  get daysToKeepGaebToAva(): number { return this._daysToKeepGaebToAva(); }
  set daysToKeepGaebToAva(value: number) { this._daysToKeepGaebToAva.set(value); }
  requestEnRoute = signal(false);

  ngOnInit(): void {
    this.conversionArchivesClient
      .getOldestConversionPresent(ConversionDataType.AvaProject, ConversionDataType.AvaProject, false)
      .subscribe(r => {
        this.oldestAvaToAvaConversionPresent.set(r.runAtUtc);
      });

    const targets = [ConversionDataType.Gaeb90, ConversionDataType.Gaeb2000, ConversionDataType.GaebXml];
    combineLatest([
      ...targets.map(t =>
        this.conversionArchivesClient.getOldestConversionPresent(t, ConversionDataType.AvaProject, true).pipe(catchError(() => of(null)))
      )
    ]).subscribe(r => {
      const nonNulls = r.filter(x => x !== null);
      if (nonNulls.length === 0) {
        return;
      }

      const oldestData = nonNulls.sort((a, b) => (a.runAtUtc > b.runAtUtc ? 1 : -1))[0];
      this.oldestGaebToAvaConversionWithoutPersistencePresent.set(oldestData.runAtUtc);
    });
  }

  scheduleArchiving(): void {
    if (this.daysToKeep > 0 && !this.requestEnRoute()) {
      this.requestEnRoute.set(true);
      this.conversionArchivesClient
        .scheduleArchivingForConversions({
          destinationType: ConversionDataType.AvaProject,
          sourceType: ConversionDataType.AvaProject,
          maxDaysToKeep: this.daysToKeep
        })
        .subscribe({
          next: () => {
            // We're not doing anything actually
            this.requestEnRoute.set(false);
          },
          error: () => {
            this.requestEnRoute.set(false);
          }
        });
    }
  }

  scheduleArchivingGaebToAva(): void {
    if (this.daysToKeepGaebToAva > 0 && !this.requestEnRoute()) {
      this.requestEnRoute.set(true);
      this.conversionArchivesClient
        .scheduleArchivingForConversions({
          destinationType: ConversionDataType.AvaProject,
          sourceType: ConversionDataType.GaebXml,
          maxDaysToKeep: this.daysToKeepGaebToAva
        })
        .subscribe({
          next: () => {
            // We're not doing anything actually
            this.requestEnRoute.set(false);
          },
          error: () => {
            this.requestEnRoute.set(false);
          }
        });
    }
  }
}
